import { invokeApi } from "../bl_libs/invokeApi";

export const login_user_api = async (data) => {
  const requestObj = {
    path: `api/users/login`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};
